package io.horion.cv.components.forms

import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.remember
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.framework.annotations.DelicateApi
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import com.varabyte.kobweb.silk.style.toModifier
import com.varabyte.kobweb.silk.theme.breakpoint.rememberBreakpoint
import io.horion.cv.viewModel.LetterViewModel
import io.horion.cv.components.cards.GenericFormCard
import io.horion.cv.components.cards.SummaryData
import io.horion.cv.components.widgets.AddButton
import io.horion.cv.di.koinGet
import io.horion.cv.models.PieceJointe
import io.horion.cv.styles.PersonalFormMainColumnStyle
import org.jetbrains.compose.web.css.px

@OptIn(DelicateApi::class)
@Composable
fun PieceJointeAccordionContent(
    onComplete: (String) -> Unit,
    onAddCompetenceAndClose: (String) -> Unit
) {
    val letterViewModel = koinGet<LetterViewModel>()
    val letterUiState = letterViewModel.letterUiState
    val pieceJointeFromVM = letterUiState.data.others

    LaunchedEffect(Unit) {
        if (pieceJointeFromVM.isEmpty()) {
            letterViewModel.updatePieceJointe(0, "")
            letterViewModel.editingPieceJointeId = "piece_jointe-0"
        }
    }

    Column(
        modifier = PersonalFormMainColumnStyle.toModifier()
    ) {
        pieceJointeFromVM.forEachIndexed { index, pieceJointeText ->
            val tempId = "piece_jointe-$index"

            val pieceJointe = remember(pieceJointeText) {
                PieceJointe(id = tempId, piece_jointe = pieceJointeText)
            }

            GenericFormCard(
                item = pieceJointe,
                isEditing = letterViewModel.editingPieceJointeId == tempId,
                onEdit = { letterViewModel.editingPieceJointeId = tempId },
                onDelete = {
                    letterViewModel.deletePieceJointe(index)
                    if (letterViewModel.letterUiState.data.others.isEmpty()) {
                        letterViewModel.updatePieceJointe(0, "")
                        letterViewModel.editingPieceJointeId = "piece_jointe-0"
                    } else {
                        letterViewModel.editingPieceJointeId = null
                    }
                },
                onComplete = { letterViewModel.editingPieceJointeId = null },
                getSummary = { pj ->
                    if (pj.piece_jointe.isNotBlank()) {
                        SummaryData(title = pj.piece_jointe, subtitle = "")
                    } else null
                },
                getDefaultText = { "[Piece Jointe]" },
                formContent = { s, onDel, onComp ->
                    PieceJointeForm(
                        index = index,
                        pieceJointe = s,
                        letterViewModel = letterViewModel,
                        onDelete = onDel,
                        onComplete = onComp
                    )
                }
            )
        }

        AddButton(
            text = "Ajouter une pièce jointe",
            onClick = {
                val nextIndex = pieceJointeFromVM.size
                letterViewModel.updatePieceJointe(nextIndex, "")
                letterViewModel.editingPieceJointeId = "piece_jointe-$nextIndex"
            }
        )
    }
}

